export enum ActionTypes {
  UpdatePlaidUserInfo = 'UI/UpdatePlaidUserInfo',
  SetEnableDocUpload = 'UI/SetEnableDocUpload',
  SetUserDetails = 'UI/SetUserDetails',
}
